import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { SectionHead } from "@/components/site/Reveal";

export const Temoignages = () => (
  <section className="relative py-24 md:py-36" data-testid="temoignages-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHead
        label="Avis clients"
        title={
          <>
            Ils nous font <span className="text-gradient">confiance.</span>
          </>
        }
      />
      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="card-surface rounded-2xl p-8 flex flex-col"
            data-testid={`testimonial-${i}`}
          >
            <Quote size={22} className="text-[var(--accent-violet)] mb-5" />
            <blockquote className="text-[var(--text-secondary)] text-sm md:text-base leading-relaxed flex-1">
              « {t.quote} »
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-white/[0.06]">
              <p className="font-display font-bold">{t.name}</p>
              <p className="text-xs text-[var(--text-muted)] mt-1">{t.role}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Temoignages;
